// Montagem do path de fotos no Supabase Storage (spec S02 §Fotos): bucket
// `project-photos` (já existe, ver supabase/migrations/001_initial_schema.sql)
// com policy por dono no formato `{user_id}/{project_id}/...` — o path
// abaixo é o que vai DENTRO do bucket (passado para
// `supabase.storage.from(PROJECT_PHOTOS_BUCKET).upload(path, ...)`), não
// inclui o nome do bucket.
export const PROJECT_PHOTOS_BUCKET = 'project-photos';

export interface ProjectPhotoStoragePathParams {
  userId: string;
  projectId: string;
  photoId: string;
}

/**
 * `{user_id}/{project_id}/{photo_id}.jpg` — o `photo_id` aqui é só um
 * identificador para nomear o arquivo (gerado com uuidv7 pela UI ANTES do
 * upload, ver ProjectPhotosSection); não precisa ser o mesmo id da linha
 * `project_photos` gravada depois via insertRecord (que sempre gera seu
 * próprio id) — o que importa é que o `storage_path` final gravado na linha
 * aponte para este path.
 */
export function buildProjectPhotoStoragePath({ userId, projectId, photoId }: ProjectPhotoStoragePathParams): string {
  return `${userId}/${projectId}/${photoId}.jpg`;
}
